module.exports = __webpack_public_path__ + "img/matkailureitti_original.3125fe8a.png";